import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatCard = createCustomElementWrapper('kat-card', 'KatCard', {
    'noBodyPadding': 'no-body-padding',
}, {}, [
    'title',
    'action',
    'subtitle',
    'footer',
]);
